import React from 'react';
import { m as motion } from 'framer-motion';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import type { TomoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface TomoItemProps {
  tomo: TomoContent;
  index: number;
}
export function TomoItem({
  tomo,
  index
}: TomoItemProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut,
    delay: index % 5 * 0.05
  }} className="flex flex-col" data-id="element-283" data-mp="3v36uurl7lpsr">
      <PlaceholderMockup label={tomo.imageLabel} aspect="aspect-[4/5]" src={tomo.imageUrl} alt={`${tomo.imageLabel} — atmósfera de pista de pádel`} width={480} height={600} data-id="element-284" data-mp="3gdhnufqfqrkk" />
      <p className="mt-4 font-heading text-xs uppercase tracking-[0.18em] text-mp-lime" data-id="element-285" data-mp="vnijeg8ln0mp">{tomo.label}</p>
      <h3 className="mt-1 font-heading text-lg uppercase leading-snug text-mp-white" data-id="element-286" data-mp="qoyt63mz32oj">{tomo.title}</h3>
      <p className="mt-1 text-sm leading-relaxed text-mp-gray" data-id="element-287" data-mp="fho2189x35ve">{tomo.shortDescription}</p>
    </motion.div>;
}